import {defaultConfig} from "../config"
import storeProvider from '../storeProvider'

export function getUrlPrefix(){
  if(storeProvider.getStore().getState().otherUser.loggedIn) return defaultConfig.url+"/other-user"

  return defaultConfig.url
}

export function getHeaders(headers = false){
  let defaultHeaders = {
    Authorization: "Bearer " + localStorage.getItem('login_token'),
    Accept: 'application/json',
    'User-Language': storeProvider.getStore().getState().i18n.locale
  }

  if(storeProvider.getStore().getState().otherUser.loggedIn){
    defaultHeaders = {
      ...defaultHeaders,
      'Authorization-Other-User': localStorage.getItem('other_user_token')
    }
  }

  if(headers){
    defaultHeaders = {
      ...defaultHeaders,
      ...headers
    }
  }

  return defaultHeaders
}



// WEBPACK FOOTER //
// ./src/js/helpers/urlHelper.js